import { CleanedEnvAccessors, cleanEnv, str, url } from 'envalid'

export const env = cleanEnv(window._env_, {
  REACT_API_URL: url({ devDefault: 'http://localhost:8080' }),
  REACT_APP_VERSION: str({ devDefault: 'development' }),
  REACT_APP_SENTRY_DSN_REACT: str(),
})

export type env = Omit<typeof env, keyof CleanedEnvAccessors>
